import BrowserClass from './util/BrowserClass.js';
import SmoothScroll from 'smooth-scroll';
import scrollDirection from './util/ScrollDirection';

class TopIssueEvent {
  issueListEl = null;
  solutionEl = null;

  constructor() {
    this.start();
  }

  start() {
    this.issueListEl = document.getElementById("js-top-issue-list");
    this.solutionEl = document.getElementById("js-top-issue-solutions");
    if(
      this.issueListEl == null ||
      this.solutionEl == null
    ) return;

    if(window.innerWidth < 769) return;

    console.log(" start TopIssueEvent ");

    this.issueListEl = this.issueListEl.querySelectorAll("li");
    this.solutionEl = this.solutionEl.querySelectorAll("p");

    const issueObserver = new IntersectionObserver(this.issueCallback.bind(this), {
      threshold: 0,
      rootMargin: '-49% 0px -49% 0px'
    });

    this.issueListEl.forEach((item, index) => {
      item.setAttribute("index", index);
      issueObserver.observe(item);
    });
  }

  issueCallback(e) {
    // 外に出た場合は処理しない
    if(!e[0].isIntersecting) return;

    this.issueListEl.forEach((item) => {
      item.classList.remove("-active");
    });
    this.solutionEl.forEach((item) => {
      item.classList.remove("-show");
    });

    e[0].target.classList.add("-active");
    const attr = e[0].target.getAttribute("index");
    this.solutionEl[attr].classList.add("-show")
  }
}


class TopCaseEvent {
  caseDecEl = null;
  caseCordEl = null;
  caseBarEl = null;

  constructor() {
    this.start();
  }

  start() {
    this.caseDecEl = document.querySelectorAll(".js-top-case-desc");
    this.caseCordEl = document.querySelectorAll(".js-top-case-cord");
    this.caseBarEl = document.querySelector(".js-top-case-paging-bar");

    if(
      this.caseDecEl == null ||
      this.caseCordEl == null
    ) return;

    // スマホでは動きを変える
    if(window.innerWidth < 769) return;

    console.log("!!! TopCaseEvent !!!");


    const caseObserver = new IntersectionObserver(this.caseCallback.bind(this), {
      threshold: 0,
      rootMargin: '-49% 0px -49% 0px'
    });

    this.caseCordEl.forEach((item, index) => {
      item.setAttribute("index", index);
      caseObserver.observe(item);
    });
  }


  caseCallback(e) {
    // 外に出た場合は処理しない
    if(!e[0].isIntersecting) return;

    this.caseDecEl.forEach((item) => {
      gsap.to(item, { opacity: 0, y: '50' , duration: 0.2});
    });

    const attr = e[0].target.getAttribute("index");

    gsap.to(this.caseDecEl[attr], { opacity: 1, y: '0', duration: 0.4});

    const width =  ((Number(attr) + 1) / this.caseDecEl.length) * 100;

    gsap.to(this.caseBarEl, { width: width + '%', duration: 0.4 });
  }

}


/**
 * 実行
 */
const start = () => {
  // 読み込み時にアニメーションが実行される事を防ぐ
  document.getElementsByTagName('body')[0].classList.remove('preload');

  BrowserClass.init();

  console.log("js start");


  const topMv = document.querySelector(".js-top-mv");

  new TopIssueEvent();
  new TopCaseEvent();

  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll(".js-show-anime").forEach((item, index) => {
    gsap.from(item, {
      y: '100rem',
      opacity: 0,
      duration: 1.5,
      ease: "power4.out",
      // スクロールトリガーの設定
      scrollTrigger: {
        trigger: item, // 対象物
      },
    });
  });


  // spメニューを開く処理
  const menuOpenBtnEl = document.getElementById("js-sp-menu-open");
  const menuCloseBtnEl = document.getElementById("js-sp-menu-close");
  const menuEl = document.getElementById("js-sp-menu");

  menuOpenBtnEl.addEventListener("mouseup", () => {
    menuEl.classList.add("-open");
  });
  menuCloseBtnEl.addEventListener("mouseup", () => {
    menuEl.classList.remove("-open");
  });


  // sp解決できる課題アコーディオン
  const spIssue = document.getElementById("js-top-issue-sp-list");

  if(spIssue != null) {
    const spIssueSet = spIssue.querySelectorAll('[data-item-set]');
    spIssueSet.forEach((item) => {
      const question = item.querySelector('[data-question]');
      const answer = item.querySelector('[data-answer]');

      gsap.set(answer,{
        height: 0,
        paddingTop: 0,
        paddingBottom: 0
      });

      question.addEventListener('click', (e) => {
        const isOpen = question.classList.contains('open');

        (isOpen)
        ? question.classList.remove("open")
        : question.classList.add("open")


        gsap.to(answer,{
          height: (isOpen) ? 0 : 'auto',
          paddingTop: (isOpen) ? 0 : '16rem',
          paddingBottom: (isOpen) ? 0 : '16rem',
          duration: 0.2,
        });
      });
    });
  };

  const spContactEl = document.getElementById("js-sp-contact");
  scrollDirection.setUpCollBack(() => spContactEl.classList.add("-show"));
  scrollDirection.setDownCollBack(() => spContactEl.classList.remove("-show"));

  // contact form 7 送信完了語のリダイレクト
  document.addEventListener( "wpcf7mailsent",function( event ){
    location = "/contact/thanks/";
  }, false );


  // スワイパー
  const swiper = new Swiper(".swiper2", {
    spaceBetween: 12,
    slidesPerView: 4
  });

  const swiper2 = new Swiper(".swiper", {
    thumbs: {
      swiper: swiper
    },
    navigation: {
      nextEl: ".p-slider__button-next",
      prevEl: ".p-slider__button-prev"
    },
    loop: true
  });

  /**
   * smooth-scroll
   */
  const smoothScroll = new SmoothScroll('a[href*="#"]', {
    speed: 200,
    easing: 'easeInOutCubic',
    offset: function (anchor, toggle) {
      return 75;
    },
  });
};

start();

// window.onload = function() {
//   start();
// };
